import {toggleButtonClasses, ThemeOptions, Breakpoints} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiToggleButton = ({toggle}: Tokens, mediaQueries: Breakpoints): ThemeOptions['components'] => ({
  MuiToggleButton: {
    defaultProps: {
      disableRipple: false,
      focusRipple: false,
      disableTouchRipple: false
    },
    styleOverrides: {
      root: {
        padding: toggle.desktop.padding.all,
        color: toggle.unselected.desktop.font.color,
        fontSize: toggle.desktop.font.size,
        fontWeight: toggle.desktop.font.weight,
        borderColor: toggle.unselected.desktop.border.color,
        borderRadius: 4,
        textTransform: 'none',
        '&:hover': {
          backgroundColor: toggle.desktop.hover.background.color,
          borderColor: toggle.desktop.hover.background.color,
          color: toggle.desktop.hover.font.color
        },
        [`&.${toggleButtonClasses.selected}`]: {
          backgroundColor: toggle.desktop.active.background.color,
          color: toggle.desktop.active.font.color,
          borderColor: toggle.desktop.active.border.color,
          '&:hover': {
            backgroundColor: toggle.desktop.hover.background.color
          }
        },
        [mediaQueries.down('sm')]: {
          fontSize: toggle.mobile.font.size,
          lineHeight: toggle.mobile.font.lineHeight,
          weight: toggle.mobile.font.weight
        }
      }
    }
  }
});
